// extracted by mini-css-extract-plugin
module.exports = {"DoormatLinks":"DoormatLinks_DoormatLinks__3HOHx","DoormatTerms":"DoormatLinks_DoormatTerms__1M8P-","DoormatSubLink":"DoormatLinks_DoormatSubLink__2NWbr"};